import { combineReducers } from "redux";
import { MONEY_CONVERT_DATA_SUCCESS } from "../actions/index";

const initialState = {
  covertedData: [],
};

const MoneyConvertDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case MONEY_CONVERT_DATA_SUCCESS:
      return { ...state, covertedData: action.payload };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  covertedData: MoneyConvertDataReducer,
});

export default rootReducer;
